import React, { HTMLAttributes, ReactNode } from 'react';

import { tv } from 'tailwind-variants';

import cn from '@/helpers/utils/classNames';

interface ParagraphProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
  className?: string;
  variant?:
    | 'primary'
    | 'secondary'
    | 'light'
    | 'dark'
    | 'dark-red'
    | 'light-gray'
    | 'medium-gray'
    | 'dark-gray'
    | 'silver'
    | 'orange'
    | 'link';
}

export const paragraphStyles = tv({
  variants: {
    color: {
      primary: 'text-primary',
      secondary: 'text-secondary-light',
      light: 'text-white',
      dark: 'text-black',
      orange: 'text-orange-400',
      'dark-red': 'text-dark-red',
      'light-gray': 'text-grayscale-95',
      'medium-gray': 'text-grayscale-80',
      'dark-gray': 'text-grayscale-96',
      silver: 'text-silver',
      link: 'text-link',
    },
  },
});

// xs:text-sm xs:leading-5 leading-6 sm:text-base md:text-base
const Paragraph = ({ children, className, variant = 'light-gray', ...rest }: ParagraphProps) => {
  return (
    <p
      className={cn(
        paragraphStyles({
          color: variant,
        }),
        'font-circular-std text-[1rem] font-normal leading-[26px]',
        className
      )}
      {...rest}
    >
      {children}
    </p>
  );
};

export default Paragraph;
